import { AxiosStatic } from 'axios';

import { AbstractDirectPhoneCallGatewayStrategy } from 'src/components/phoneCall/phoneCallGateway/AbstractDirectPhoneCallGatewayStrategy';
import { DirectPhoneCallGatewayStrategy } from 'src/components/phoneCall/phoneCallGateway/DirectPhoneCallGatewayStrategy';
import { sendGenericPostRequest } from 'src/components/phoneCall/phoneCallGateway/genericPostRequest/sendGenericPostRequest';

import { OutgoingCallConfigurationForTheUser } from 'src/models/phoneCall';

import { CommandBus } from 'src/util/command/CommandBus';

export class GenericPostDirectPhoneCallGatewayStrategy
	extends AbstractDirectPhoneCallGatewayStrategy
	implements DirectPhoneCallGatewayStrategy
{
	private readonly axios: AxiosStatic;
	private readonly outGoingCallConfigurationForTheUser: OutgoingCallConfigurationForTheUser;

	constructor(
		axios: AxiosStatic,
		commandBus: CommandBus,
		authenticatedUserId: number,
		outGoingCallConfigurationForTheUser: OutgoingCallConfigurationForTheUser
	) {
		super(commandBus, authenticatedUserId);
		this.axios = axios;
		this.outGoingCallConfigurationForTheUser = outGoingCallConfigurationForTheUser;
	}

	public async makeCall(callerName: string, toNumber: string): Promise<null | string> {
		await sendGenericPostRequest(this.axios, this.outGoingCallConfigurationForTheUser.url_init as string, {
			number: toNumber,
			terminal: this.outGoingCallConfigurationForTheUser.terminal,
		});

		return await this.createPhoneCall(callerName, toNumber);
	}
}
